import { render, staticRenderFns } from "./Comp3.vue?vue&type=template&id=752e5184&scoped=true&"
import script from "./Comp3.vue?vue&type=script&lang=js&"
export * from "./Comp3.vue?vue&type=script&lang=js&"
import style0 from "./Comp3.vue?vue&type=style&index=0&id=752e5184&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e5184",
  null
  
)

export default component.exports